const Socials = {
  facebook: 'RooseveltCollier',
  instagram: 'rooseveltcolliermusic',
  twitter: 'RooseveltTheDr',
  spotify: '7b10aYN6jh7Dai5c4tshD9',
  youtube: 'playlist?list=PLr6tPF2FpNsWzm22fIz6l1_hfLeQoPOZc'
};

export default Socials;
